<script lang="ts">

    import Icon from "../atoms/Icon.svelte";

    export let text: string;
    export let iconLeft: string = undefined;
    export let iconRight: string = undefined;
</script>

<div class="info-banner">
    <div class="info-banner__iconLeft">
        {#if iconLeft}
            <Icon src={iconLeft} size={24}/>
        {/if}
    </div>
    <span class="info-banner__text">{text}</span>
    {#if iconRight}
        <Icon src={iconRight} width={40} height={30}/>
    {/if}
</div>

<style>
    .info-banner {
        display: flex;
        align-items: center;
        gap: 20px;
        align-self: stretch;
        justify-content: space-between;
        padding: 12px 20px 12px 12px;
        border-radius: 6px;

        /* TODO: Use new color scheme after map rework */
        background: #D3E8FD;
    }

    .info-banner__text {
        width: 100%;
        font-family: Roboto, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        /* TODO: Use new color scheme after map rework */
        color: #0B70D6;
    }

    .info-banner__iconLeft {
        display: flex;
        width: 44px;
        align-items: center;
        gap: 10px;
        align-self: stretch;

        &::before {
            content: "";
            display: block;
            width: 2px;
            height: 32px;
            /* TODO: Use new color scheme after map rework */
            background: #0B70D6;
            border-radius: 999px;
        }
    }
</style>
